const PROMOTION_POPUP_UTM_SUPPRESSION_COOKIE =
  'nationalPromoPopupUtmSuppressed';

export const getSessionCookieName = (name) => encodeURIComponent(name);

export const hasSessionCookie = (name) => {
  const cookieName = getSessionCookieName(name);
  return document.cookie
    .split('; ')
    .some((cookie) => cookie === `${cookieName}=true`);
};

export const setSessionCookie = (name) => {
  document.cookie = `${getSessionCookieName(name)}=true; path=/;`;
};

export const hasUtmQueryValue = (search = '') => {
  const searchParams = new URLSearchParams(search);

  return Array.from(searchParams.entries()).some(
    ([key, value]) => key.toLowerCase().includes('utm') && !!value,
  );
};

export const shouldSuppressPromotionPopupForSession = () => {
  if (hasUtmQueryValue(window.location.search)) {
    setSessionCookie(PROMOTION_POPUP_UTM_SUPPRESSION_COOKIE);
    return true;
  }

  return hasSessionCookie(PROMOTION_POPUP_UTM_SUPPRESSION_COOKIE);
};
